"use client"

import React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { ConfirmButton } from "@src/components/Button"
import { useRouter } from "next/navigation"
import { ROUTES } from "@src/constants"

interface ApplicationSuccessProps {
  onClose?: () => void
}

const ApplicationSuccess: React.FC<ApplicationSuccessProps> = ({ onClose }) => {
  const router = useRouter()

  const handleBackToHome = () => {
    router.push(ROUTES.RECRUITMENT_JOB)
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "400px",
        padding: "40px 20px",
        textAlign: "center",
        position: "relative",
        marginTop: '1rem'
      }}
    >
      {/* Icon Section */}
      <Box
        sx={{
          height: {
            xs: "200px",
            md: "300px"
          },
          width: {
            xs: "200px",
            md: "300px"
          },
          borderRadius: "50%",
          backgroundColor: "#F0F0F0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          marginBottom: "24px",
        }}
      >
        <svg
          width="420"
          height="420"
          viewBox="0 0 420 420"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="210" cy="210" r="210" fill="#EBEBEB" />
          <path
            d="M297.594 245.487C270.303 245.487 248.303 267.52 248.303 294.8C248.303 322.081 270.303 344.07 297.594 344.07C324.886 344.07 346.886 322.081 346.886 294.8C346.886 267.52 324.886 245.487 297.594 245.487ZM326.701 274.165C328.96 274.105 331.025 275.437 331.9 277.518C332.778 279.603 332.283 282.008 330.658 283.579L292.651 321.586H292.654C291.626 322.616 290.229 323.195 288.775 323.195C287.322 323.195 285.925 322.616 284.897 321.586L260.84 297.529C259.775 296.507 259.166 295.1 259.152 293.624C259.139 292.145 259.718 290.727 260.761 289.683C261.808 288.639 263.226 288.063 264.702 288.08C266.18 288.096 267.586 288.707 268.607 289.773L288.781 309.979L322.937 275.823C323.929 274.803 325.28 274.208 326.701 274.165Z"
            fill="black"
          />
          <path
            d="M89.4654 125C88.0114 125.003 86.6172 125.584 85.5927 126.614C84.568 127.647 83.9946 129.044 84 130.498V142.896C124.165 166.075 164.33 189.26 204.488 212.448C244.652 189.263 284.817 166.073 324.975 142.885V130.498C324.989 127.473 322.545 125.011 319.521 125H89.4654ZM84 155.571V283.851C84.0109 286.862 86.4541 289.3 89.4654 289.305H237.629C240.42 258.669 266.241 234.538 297.595 234.538C307.458 234.538 316.752 236.965 324.979 241.191V155.574C285.735 178.228 246.486 200.869 207.24 223.522C205.538 224.508 203.44 224.508 201.742 223.522C162.495 200.872 123.249 178.226 84.0023 155.574L84 155.571Z"
            fill="black"
          />
        </svg>
      </Box>

      {/* Heading */}
      <Box
        sx={{
          backgroundColor: "#F0F0F0",
          borderRadius: "20px",
          padding: "12px 24px",
          marginBottom: "24px",
          marginTop: "1rem"
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 500,
            fontSize: { xs: "18px", md: "20px" },
            color: "black",
            margin: 0
          }}
        >
          Ứng tuyển thành công!
        </Typography>
      </Box>

      {/* Description */}
      <Box
        sx={{
          marginBottom: "32px",
          fontStyle: "italic",
          fontWeight: 500,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "14px", md: "16px" },
            color: "black",
            lineHeight: 1.5,
          }}
        >
          Thông tin của bạn đã được gửi đến công ty.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "14px", md: "16px" },
            color: "black",
            lineHeight: 1.5
          }}
        >
          THE C.I.U sẽ phản hồi qua email trong vòng 3-5 ngày làm việc.
        </Typography>
      </Box>

      {/* Call-to-Action Button */}
      <ConfirmButton
        label="Về trang chủ"
        onClick={handleBackToHome}
        sx={{
          height: '20px',
          backgroundColor: "black !important",
          color: "white !important",
          borderRadius: "15px",
          padding: "12px 32px !important",
          fontSize: "16px",
          fontWeight: 500,
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#333 !important"
          }
        }}
      />
    </Box>
  )
}

export default ApplicationSuccess
